module.exports = __webpack_public_path__ + "media/images/new_culture/bg-10-70dfa322617165712d0d16fd2720a319.jpeg";